import { ifCanPushDatalayer } from "./utils/utils.dataLayer.common";
import { decodeHtml } from "../utils/utils.common";
import categorizeMarketoFormSubmission from "./form-categorize-submission.common";

//UCS007
const dataLayerFormResources = (userStatus, userEmail, marketoIDF) => {
    ifCanPushDatalayer({
        then: () => {
            const form = document.querySelector("[data-form-id]");
            const formID = form ? form.dataset.formId : "";
            const resourceType = document.querySelector("[data-resource-type]");
            const resourceTypeID = resourceType ? resourceType.dataset.resourceType.toLowerCase() : "";

            if (formID === "resources_details" && resourceType) {
                if (userEmail || Cookies.get('marketo_id')) {
                    categorizeMarketoFormSubmission({
                        userEmail,
                        userStatus,
                        leadType: decodeHtml(resourceTypeID),
                        marketoIDF
                    });
                }
            }
        },
    });
};

export default dataLayerFormResources;
